import { ceil as lo_ceil } from 'es-toolkit/compat';

type convertGramsAndMm = [feet: number, inches: number] | undefined;

// val: 6' 10"
export const parseFtInString = (val: string): [number, number] => {
    const [strFeet, strInches] = val?.split("'");
    const feet = parseFloat(String(strFeet)) ?? 0;
    const inches = parseFloat(String(strInches)) ?? 0;

    return [feet, inches];
};

export const formatFtIn = ([feet, inches]: [number, number]): string => {
    return `${feet}' ${inches}"`;
};

export const convertFtInToIn = ([feet, inches]: [number, number]): number => {
    return feet * 12 + inches;
};

export const convertInToFtIn = (inchesTotal: number): [number, number] => {
    const feet = Math.trunc(inchesTotal / 12);
    const inches = inchesTotal % 12;
    return [feet, inches];
};


// Rounds inches to nearest 0.5
export const convertMmToFtIn = (val: number): [number, number] => {
    const totalInches = val / 25.4;
    const feet = Math.floor(totalInches / 12);
    const inches = Math.round((totalInches % 12) / 0.5) * 0.5;

    return [feet, inches];
};

export const convertMmToFtInString = (val: number): string => {
    const [feet, inches] = convertMmToFtIn(val);
    return `${feet}' ${inches}"`;
};

// val: 6' 10"
export const convertFtInToMm = ([feet, inches]: [number, number]): number => {
    const value = (feet * 12 + inches) * 25.4;
    return lo_ceil(value, 2);
};

export const convertFtInToMmString = (val: string): number => {
    const [feet, inches] = parseFtInString(val);
    const value = (feet * 12 + inches) * 25.4;

    return lo_ceil(value, 2);
};

export const convertMmToFt = (val: number): number => {
    return lo_ceil(val * 0.003281, 2);
};

export const convertFtToMm = (val: number): number => {
    return lo_ceil(val / 0.003281, 2);
};
